<template>
  <div class="register" v-if="completed">
    <h1 class="page-title">{{completed.message}}</h1>
  </div>
  <div class="register" v-else>
    <h1 class="page-title">{{$t('form.register')}}</h1>
    <p class="m-b-5">Bitte füllen Sie das unten stehende Formular vollständig aus, um die kostenlose Master Mass Digital App nutzen zu können. Nach Überprüfung Ihrer Daten erhalten Sie von uns ein Bestätigungsmail mit Download-Link zur App.
    </p>
    <form @submit.prevent="onSubmit" style="width: 100%;">
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="first_name"
            name="first_name"
            required
            :label="`${$t('form.first_name')}:`"
            :vvas="$t('form.first_name')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="last_name"
            name="last_name"
            required
            :label="`${$t('form.last_name')}:`"
            :vvas="$t('form.last_name')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="country_id"
            name="country_id"
            required
            :label="`${$t('form.country')}:`"
            :vvas="$t('form.country')"
            :options="countries"
          />
        </div>
        <div class="column">
          <field-select
            :value.sync="state_id"
            name="state_id"
            required
            :title="!country_id && $t('message.please_select_country')"
            :disabled="!country_id"
            :options="stateOptions"
            :label="`${$t('form.state')}:`"
            :vvas="$t('form.state')"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="city"
            name="city"
            required
            :label="`${$t('form.city')}:`"
            :vvas="$t('form.city')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="street_name"
            name="street_name"
            required
            :label="`${$t('form.street_name')}:`"
            :vvas="$t('form.street_name')"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="street_number"
            name="street_number"
            required
            :label="`${$t('form.street_number')}:`"
            :vvas="$t('form.street_number')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="zipcode"
            name="zipcode"
            v-validate="'length:4'"
            :label="`${$t('form.zipcode')}:`"
            :vvas="$t('form.zipcode')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="email"
            name="email"
            type="email"
            required
            :label="`${$t('form.email')}:`"
            :vvas="$t('form.email')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="phone_number"
            name="phone_number"
            required
            :prefix="country_id && dialCode"
            :title="!country_id && $t('message.please_select_country')"
            :disabled="!country_id"
            :label="`${$t('form.phone_number')}:`"
            :vvas="$t('form.phone_number')"
          />
        </div>
      </div>

      <hr />

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="company"
            name="company"
            required
            v-validate="'min:3'"
            :label="`${$t('form.company')}:`"
            :vvas="$t('form.company')"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="tax_id"
            name="tax_id"
            required
            :label="`${$t('form.tax_id')}:`"
            :vvas="$t('form.tax_id')"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <field-select
            :value.sync="industry_branch_id"
            name="category"
            required
            :label="`${$t('form.branch')}:`"
            :vvas="$t('form.branch')"
            :options="industry_branches"
          />
        </div>
      </div>
      <hr />

      <div class="columns">
        <div class="column">
          <field-input
            :value.sync="password"
            name="password"
            required
            autocomplete="off"
            :label="`${$t('form.password')}: (min: 6 ${$t('form.characters')})`"
            :vvas="$t('form.password')"
            type="password"
          />
        </div>
        <div class="column">
          <field-input
            :value.sync="password_confirmation"
            name="password_confirmation"
            required
            autocomplete="off"
            :label="`${$t('form.password_confirmation')}:`"
            :vvas="$t('form.password_confirmation')"
            type="password"
          />
        </div>
      </div>

      <div class="field m-t-5">
        <div class="control is-clearfix">
          <button
            class="button is-primary is-pulled-right"
            :class="{ 'is-loading': formLoading }"
          >{{ $t("form.submit") }}</button>
        </div>
      </div>
    </form>

    <div class="m-t-5 m-b-5">
      <p>Selbstverständlich geben wir Ihre Daten niemals an Dritte weiter. Für mehr Details lesen Sie bitte unsere <nuxt-link :to="localePath('privacy-policy')">Datenschutzrichtlinien</nuxt-link>.</p>
    </div>
  </div>
</template>

<script>
export default {
  layout: "auth",

  middleware: 'onlyDe',

  data() {
    return {
      formLoading: false,
      completed: false,

      first_name: null,
      last_name: null,
      company: null,
      email: null,
      phone_number: null,
      country_id: null,
      state_id: null,
      city: null,
      zipcode: null,
      street_name: null,
      street_number: null,
      tax_id: null,
      password: null,
      password_confirmation: null,
      industry_branch_id: null
    };
  },

  watch: {
    country_id() {
      this.state_id = null;
    }
  },

  computed: {
    countries() {
      return this.$store.getters["options/countries"];
    },

    industry_branches() {
      return this.$store.state.options.industry_branches;
    },

    dialCode() {
      if (this.country_id === null || this.country_id === undefined) return;
      return this.choosenCountry && this.choosenCountry.dial_code;
    },

    choosenCountry() {
      return this.countries.find(e => e.id === this.country_id);
    },

    stateOptions() {
      if (this.country_id === null || this.country_id === undefined) return;
      return this.choosenCountry && this.choosenCountry.states;
    },

    typeOptions() {
      return [
        {
          id: "glass",
          name: this.$t("form.glass")
        },
        {
          id: "hinge",
          name: this.$t("form.hinge")
        },
        {
          id: "wood",
          name: this.$t("form.wood")
        },
        {
          id: "stone",
          name: this.$t("form.stone")
        }
      ];
    }
  },

  methods: {
    async onSubmit() {
      const validation = await this.$validator.validateAll();
      if (!validation) return;

      this.formLoading = true;

      const request = {
        first_name: this.first_name,
        last_name: this.last_name,
        company: this.company,
        email: this.email,
        phone_number: this.phone_number,
        country_id: this.country_id,
        state_id: this.state_id,
        city: this.city,
        zipcode: this.zipcode,
        street_name: this.street_name,
        street_number: this.street_number,
        tax_id: this.tax_id,
        password: this.password,
        password_confirmation: this.password_confirmation,
        industry_branch_id: this.industry_branch_id
      };

      try {
        const { data } = await this.$api.registerUser(request);
        this.completed = data;
        this.$toast.success(this.$t("form.successfully_registred"));
        this.$router.push("/")
      } catch (e) {
        const splittedMessage = e.response.data.split('validating');
        const errorMessage = splittedMessage[1];
        const replacedMessage = errorMessage.replace(errorMessage, "[" + errorMessage + "]");
        const parsedMessAage = JSON.parse(replacedMessage);
        const output = parsedMessAage[0].message;
      
        this.$toast.error(output);
      }

      this.formLoading = false;
    }
  }
};
</script>

<style lang="scss">
.register {
  .label {
    color: #fff !important;
  }

  .page-title {
    font-size: 32px;
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/nuxt/pages/register/index.vue